/**
 * StaticPageLayout — Shared layout for legal and informational pages
 * Used by Privacy, Terms, Cookie Policy, Security, and About pages.
 */
import { Link } from 'react-router-dom';
import AscendingK from '../components/AscendingK';

export default function StaticPageLayout({ title, children }) {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--paper)' }}>
      {/* Nav */}
      <nav style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '24px 48px', borderBottom: '1px solid var(--rule)',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
          <AscendingK size={24} />
          <span className="serif" style={{ fontSize: 18, fontWeight: 400, color: 'var(--ink)' }}>
            connekted <em style={{ color: 'var(--brand)' }}>in</em>
          </span>
        </Link>
        <Link
          to="/auth"
          className="btn btn-primary-app btn-sm"
          style={{ textDecoration: 'none', borderRadius: 'var(--r-full)', padding: '10px 20px' }}
        >
          Get started
        </Link>
      </nav>

      {/* Content */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '80px 48px' }} className="animate-fadeUp">
        <div className="mono" style={{ marginBottom: 12 }}>Connekted in</div>
        <h1 className="serif" style={{
          fontSize: 'clamp(36px, 5vw, 56px)', fontWeight: 300,
          letterSpacing: '-0.02em', marginBottom: 40,
        }}>
          {title}
        </h1>
        <div className="static-page-content" style={{ fontSize: 16, color: 'var(--muted)', lineHeight: 1.75 }}>
          {children}
        </div>
      </div>

      {/* Footer */}
      <footer style={{
        padding: '32px 48px', borderTop: '1px solid var(--rule)',
        display: 'flex', justifyContent: 'space-between', alignItems: 'baseline',
      }}>
        <span className="serif" style={{ fontStyle: 'italic', fontSize: 14, color: 'var(--ink)' }}>
          Connekted in &middot; {new Date().getFullYear()}
        </span>
        <div style={{ display: 'flex', gap: 24 }}>
          <Link to="/privacy" style={{ fontSize: 12, color: 'var(--muted)', textDecoration: 'none' }}>Privacy</Link>
          <Link to="/terms" style={{ fontSize: 12, color: 'var(--muted)', textDecoration: 'none' }}>Terms</Link>
          <Link to="/cookies" style={{ fontSize: 12, color: 'var(--muted)', textDecoration: 'none' }}>Cookies</Link>
          <Link to="/security" style={{ fontSize: 12, color: 'var(--muted)', textDecoration: 'none' }}>Security</Link>
        </div>
      </footer>
    </div>
  );
}
